import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  banner: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    marginBottom: '16px',
    borderRadius: '8px',
    border: '1px solid rgba(0, 146, 153, 0.35)',
    backgroundColor: 'rgba(0, 146, 153, 0.06)',
    flexWrap: 'wrap'
  },
  bannerText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    minWidth: 0,
    flex: 1
  },
  address: {
    fontFamily: 'monospace',
    fontSize: '14px',
    fontWeight: 600,
    wordBreak: 'break-all'
  },
  hint: {
    fontSize: '13px',
    opacity: 0.75
  }
}));
export default useStyles;